import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import AppContainer from "./routes/index";
import { Login } from "./screens";
import { Header, Footer } from "./components";
import { Provider } from "react-redux";
import store from "./stateManagement/store/store";
import "./App.scss";

function App() {
  return (
    <Provider store={store}>
      <BrowserRouter>
        <div className="app">
          <Header />
          <AppContainer />
          <Footer />
        </div>
      </BrowserRouter>
    </Provider>
  );
}

export default App;
